import React from 'react'

function MenuScreen() {
    return (
        <div>
            Menu
        </div>
    )
}

export default MenuScreen
